import {
  PIECEWORK_MAX_PO_TOTAL,
  SPECIAL_JOB_MIN_PO_TOTAL,
  RepairTypeEnum,
} from '@vatos-pas/common';

// Verbatim from the backend job-repair subscriber's BadRequestException
// messages so frontend guidance and server rejection never disagree.
export const PIECEWORK_LIMIT_MESSAGE =
  'Value is higher than the Piecework limit of $250.00, please select a different Repair Type before proceeding';
export const SPECIAL_JOB_MINIMUM_MESSAGE =
  'Value is lower than the Special Job minimum of $250.01, please select a different Repair Type before proceeding';

export type PoTotalBoundaryInput = {
  repairType: RepairTypeEnum | null | undefined;
  poTotal: number;
  nonBillable: boolean;
};

// Piecework covers PO Totals up to and including $250.00; Special Jobs cover
// everything above it — no gap, no overlap. Returns the boundary message when
// the amount is out of range for the selected type, otherwise null.
export const validatePoTotalBoundary = ({
  repairType,
  poTotal,
  nonBillable,
}: PoTotalBoundaryInput): string | null => {
  if (nonBillable) return null;
  if (!Number.isFinite(poTotal) || poTotal <= 0) return null;

  if (
    repairType === RepairTypeEnum.Piecework &&
    poTotal > PIECEWORK_MAX_PO_TOTAL
  ) {
    return PIECEWORK_LIMIT_MESSAGE;
  }

  if (
    repairType === RepairTypeEnum.SpecialJobs &&
    poTotal < SPECIAL_JOB_MIN_PO_TOTAL
  ) {
    return SPECIAL_JOB_MINIMUM_MESSAGE;
  }

  return null;
};
